import Flex from './flex';
import FlexItem from './flex-item';

Flex.Item = FlexItem;

export default Flex;
